import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import { JSX } from "react";
import ConfirmationButton from "shared/components/ConfirmationButton";
import useStore from "zustand-store";
import CloseIcon from "@mui/icons-material/Close";


type PropsType = {
    icon?: JSX.Element;
    isOpen: boolean;
    title: string;
    description: string;
    actionTitle?: string;
    action?: () => void;
}

const GlobalDialog = (props: PropsType) => {
    const { icon, isOpen, action, title, description, actionTitle } = props;
    const removeglobalDialog = useStore(state => state.removeglobalDialog);

    function handleClose(): void {
        removeglobalDialog();
        action && action();
    }

    return <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >

        <DialogTitle sx={{ p: 1, display: "flex", justifyContent: "flex-end" }}>
            <IconButton
                aria-label="close"
                onClick={handleClose}
            >
                <CloseIcon />
            </IconButton>
        </DialogTitle>

        {icon && <Box sx={{ alignSelf: 'center', "& svg, & img": { width: "90px", height: "90px" } }}>{icon}</Box>}

        <DialogContent sx={{minWidth: '300px'}}>
            <Box sx={{ justifySelf: 'center', fontSize: '1.4rem', fontWeight: 600 }}>{title}</Box>
            <DialogContentText id="alert-dialog-description" sx={{ textAlign: 'center' }}>
                {description}
            </DialogContentText>
            <ConfirmationButton
                onClick={handleClose}
                variant="contained"
                sx={{ width: "100%", mt: 5 }}
            >{actionTitle || 'Fermer'}
            </ConfirmationButton>
        </DialogContent>
    </Dialog>
}

export default GlobalDialog